type ProductPathParams = {
  genre: string;
  category: string;
  id: string;
  itemCode: string;
  mainFabricCode: string;
  itemColorCode: string;
  genderCodeAndGenderDesc: string;
  styleCodeAndStyleDesc: string;
};

const routes = {
  login: '/login',
  home: '/home',
  catalogue: '/catalogue',
  product: '/catalogue/product',
  info: '/info',
  others: '/info/others',
  technologies: '/info/technologies',
  notifications: '/notifications',
  notificationsDetails: (id: string) => `/notifications/${id}`,
  downloads: '/downloads',
  budgets: '/budgets',
  budgetDetails: (gender: string, id: string) => `/budgets/${gender}/${id}`,
  viewOrders: '/orders/view-orders',
  newOrder: '/orders/new-order',
  orders: '/orders',
  singleOrder: (orderId: string) => `/orders/view-orders/order/${orderId}`,
  statistics: '/statistics',
  selections: '/selections',
  myLists: '/selections/my-lists',
  newPassword: '/login/new-password-challenge',
  customerMapper: '/customer-mapper',
  myCustomers: '/customer-mapper/my-customers',
  newCustomer: '/customer-mapper/new-customer',
  customerDetails: (id: number | string, code: string | null) =>
    `/customer-mapper/my-customers/customer-details/${id}${code ? `?code=${code}` : ''}`,
  shopDetails: (
    id: number | string,
    shopId: string | number,
    shopModel: string,
    code: string | null
  ) =>
    `/customer-mapper/my-customers/customer-details/${id}/shop/${shopId}/${shopModel}${
      code ? `/${code}` : ''
    }`,
  prices: '/prices',
  colorsList: (params: ProductPathParams) => {
    const {
      genre,
      category,
      id,
      itemCode,
      mainFabricCode,
      itemColorCode,
      styleCodeAndStyleDesc,
      genderCodeAndGenderDesc,
    } = params;

    return `/catalogue/${genre}/${category}/${id}/list?itemCode=${itemCode}&mainFabricCode=${mainFabricCode}&itemColorCode=${itemColorCode}&genderCodeAndGenderDesc=${genderCodeAndGenderDesc}&styleCodeAndStyleDesc=${styleCodeAndStyleDesc}`;
  },
  productDetails: (params: ProductPathParams) => {
    const {
      genre,
      category,
      id,
      itemCode,
      mainFabricCode,
      itemColorCode,
      styleCodeAndStyleDesc,
      genderCodeAndGenderDesc,
    } = params;

    return `/catalogue/${genre}/${category}/${id}?itemCode=${itemCode}&mainFabricCode=${mainFabricCode}&itemColorCode=${itemColorCode}&genderCodeAndGenderDesc=${genderCodeAndGenderDesc}&styleCodeAndStyleDesc=${styleCodeAndStyleDesc}`;
  },
};

const paths = {
  subProducts: 'sub-products',
  product: 'product',
  technologies: 'technologies',
  others: 'others',
  viewOrders: 'view-orders',
  newOrder: 'new-order',
  myLists: 'my-lists',
  myCustomers: 'my-customers',
  newCustomer: 'new-customer',
  customerDetails: (id: number | string, code: string | null) =>
    `customer-details/${id}${code ? `?code=${code}` : ''}`,
  shopDetails: (id: string | number, shopModel: string, code: string | null) =>
    `shop/${id}${shopModel === '1001' ? '/online/' : '/store/'}${code ? `${code}` : ''}`,
  warehouseDetails: (id: string | number, code: string) =>
    `warehouse/${id}${code ? `/${code}` : ''}`,
  list: (id: number, name: string) => `list/${id}/${name}`,
  newAsset: (type: 'shop' | 'warehouse', code: string | undefined) =>
    `new-${type}${code ? `/${code}` : ''}`,
};

export type RouteName = keyof typeof routes;
export type PathName = keyof typeof paths;

export { routes, paths };
